module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0088.jpg?v=1266458c";